import { render, staticRenderFns } from "./DeleteResourceDialog.vue?vue&type=template&id=cdeb7308&"
import script from "./DeleteResourceDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteResourceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports